const normalizeMessageId = (value) => (value == null ? '' : String(value).trim());

export const supportsChatMessageReaction = (message) => {
  const format = String(message?.message_format || message?.messageFormat || '').trim().toLowerCase();
  return format === 'text' || format === 'image' || format === 'file';
};

export const buildReactionSummaryFromDetailGroups = (groups = []) =>
  (Array.isArray(groups) ? groups : []).map((group) => ({
    type: String(group?.type || '').trim(),
    count: Number(group?.count) || 0,
    reactedByMe: Boolean(group?.reactedByMe),
  })).filter((group) => group.type && group.count > 0);

export const patchMessageReactionSummaries = (messages = [], messageId, reactions = []) => {
  const normalizedMessageId = normalizeMessageId(messageId);
  if (!normalizedMessageId) return Array.isArray(messages) ? messages : [];
  return (Array.isArray(messages) ? messages : []).map((message) => (
    normalizeMessageId(message?.id) === normalizedMessageId
      ? { ...message, reactions: Array.isArray(reactions) ? reactions : [] }
      : message
  ));
};

export const normalizeReactionMessageId = normalizeMessageId;
